import React, { useEffect } from "react";
import './Loader.css'
import { GiSandsOfTime } from "react-icons/gi"; // Importing similar icon from React Icons

const Loader = () => {

   
    return (
        <div className="loader-container">
            <div className="loader-box">
                <GiSandsOfTime  className="loader-icon" /> {/* Replace with your icon */}
                <span className="loader-text">Loading</span>
            </div>
        </div>
    );
};

export default Loader;
